<template>
  <div class="education">
    <div class="title-font-style">教育解决方案</div>
    <div class="illustrate">
      <div>针对教育行业课程创建教学场景和虚拟仿真课件，实现教学内容的场景化和教学质量的闭环管理，突出互动性和趣味性，达到高效、有趣、安全的教学效果。</div>
    </div>
     <sub-title title-text="行业痛点"></sub-title>
    <div>
      <div class="disadvantage">数实结合的沉浸式教学体验可以实现对传统教学方式的变革，为教育行业带来全新的体验和机会。</div>
    </div>
    <sub-title title-text="方案优势"></sub-title>
    <div class="fays">
      <img :src="loadUrl.fays_bg" />
      <div>
        <div>
          <img src="@/assets/images/solution/neirong.png" />
          <div class="title">内容优势</div>
          <div class="content-text">XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div>
        </div>
        <div>
          <img src="@/assets/images/solution/jishu.png" />
          <div class="title">技术优势</div>
          <div class="content-text">以互动性+趣味性打造XR虚拟仿真教学平台，实现课程“教-学-练-考”的闭环课程体系。</div>
        </div>
        <div>
          <img src="@/assets/images/solution/chengben.png" />
          <div class="title">成本优势</div>
          <div class="content-text">通过虚拟教室和数字化教材，学校无需投入大量资金建设实体教室和购买物理教具，从而节省了大量基础设施和维护费用。</div>
        </div>
      </div>
    </div>
    <div class="yycj">
      <sub-title title-text="应用场景"></sub-title>
      <div class="yycj-content">
        <img :src="loadUrl.educationMp4" />
      </div>
    </div>
    <div class="yyal">
      <sub-title title-text="应用案例"></sub-title>
      <div class="yyal-content">
        <div v-for="(item, index) in casesList" :key="index" @click="toDetail(item.relatedHtmlId, item.title)">
          <img :src="item.ossPath" />
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div>{{ item.subTitle }}</div>
            <div class="detail">
              {{ item.introduction }}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <div class="prev" @click="changeData(Math.max(0, paginationIndex - 1) + 1)"></div>
        <div @click="changeData(item)" v-for="(item, index) in paginationValue"
          :class="paginationIndex == index ? 'active' : ''" :key="item">{{
            item }}</div>
        <div class="next" @click="changeData(Math.min(paginationIndex + 1, paginationValue - 1) + 1)"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import SubTitle from '@/components/SubTitle.vue';
const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref([])
const casesListAll: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  casesList.value = [...casesListAll.value].slice((value - 1) * 5, value * 5)
}

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `解决方案 / 教育解决方案 / ${title}`
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      casesList.value = [...casesListAll.value].slice(paginationIndex.value * 5, (paginationIndex.value + 1) * 5)
      paginationValue.value = Math.ceil(casesListAll.value?.length / 5) || 0
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.fays_bg) {
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    const educationMp4: any = await asynchronousRetrieval('webimg/gif/education.gif');
    loadUrl.value = { fays_bg, educationMp4 }
  }
})
</script>
<style scoped lang="less">
.education {
  background-color: #EFEFEF;
  padding-top: 100rem;
  overflow: hidden;

  .illustrate {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40rem 0 80rem;

    &>div {
      font-weight: 400;
      font-size: 18rem;
      color: #333333;
      width: 661rem;
      line-height: 30rem;
    }
  }

  .disadvantage {
    padding: 20rem 40rem;
    width: 1204rem;
    display: inline-block;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 8rem;
    margin: 60rem 0 40rem;
    color: #333;
    font-size: 18rem;
    line-height: 1.5;
  }

  .hytd-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 80rem;

    .hytd {
      width: 1204rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      &>div {
        width: 394rem;
        font-size: 0;

        &>div {
          padding: 30rem 29rem;
          font-weight: 400;
          font-size: 16rem;
          color: #5C5C5C;
          line-height: 30rem;
          text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
          text-align: left;
          height: 200rem;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow: 0 0 7rem 0 rgba(0, 0, 0, 0.1);
          border-radius: 0 0 8rem 8rem;

          .title {
            font-weight: 600;
            font-size: 22rem;
            color: #333333;
            line-height: 30px;
            text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
            font-family: PingFangSC-Medium;
            margin-bottom: 15rem;

            img {
              width: 47rem;
              height: 46rem;
              vertical-align: middle;
            }

            span {
              vertical-align: middle;
            }
          }
        }
      }

      .images {
        width: 393rem;
        height: 330rem;
        background: #F2F4FA;
        box-shadow: 0 0 7rem 0 rgba(0, 0, 0, 0.1);
        border-radius: 8rem 8rem 0 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0;

        img {
          width: 229rem;
          height: 250rem;
        }
      }
    }
  }

  .fays {
    position: relative;
    width: 100vw;
    height: 530rem;
    margin-top: 80rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 100rem;
    text-align: left;

    &>img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    &>div {
      width: 1200rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &>div {
        width: 393rem;
        height: 410rem;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 8rem;
        backdrop-filter: blur(10rem);
        margin: 0 5rem;
        padding: 0rem 0 40rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        font-weight: 400;
        font-size: 16rem;
        color: #333333;
        line-height: 30rem;
        text-align: center;
        overflow: hidden;

        &>div {
          padding: 0 30rem;
        }

        .title {
          font-weight: 600;
          font-size: 22rem;
          color: #333333;
          line-height: 30rem;
          font-family: PingFangSC-Medium;
          margin: 42rem 0 10rem;
        }

        .content-text {
          text-align: justify;
        }

        img {
          width: 100%;
          height: 230rem;
        }
      }
    }
  }

  .yycj {
    background-color: #fff;
    padding-top: 60rem;

    .yycj-content {
      width: 100%;
      height: 629rem;
      margin-top: 50rem;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 1120rem;
        height: 100%;
        border: 1px solid #979797;
        border-radius: 24rem;
      }
    }
  }

  .yyal {
    padding-top: 80rem;
    background-color: #fff;
    overflow: hidden;

    .yyal-content {
      margin: 80rem 0 40rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      &>div {
        width: 1040rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 60rem;
        padding: 20rem;
        border-radius: 8rem;
        cursor: pointer;

        &:hover {
          box-shadow: 0px 10px 12px 0px rgba(46, 118, 255, 0.2), 0px 0px 4px 0px rgba(46, 118, 255, 0.2);
        }

        img {
          width: 400rem;
          height: 224rem;
        }

        .content {
          width: 607rem;
          height: 224rem;
          text-align: left;
          font-weight: 600;
          font-size: 16rem;
          color: #0A0A0A;
          line-height: 22rem;
          font-family: PingFangSC-Medium;

          .title {
            font-weight: 600;
            font-size: 24rem;
            color: #0A0A0A;
            line-height: 33px;
            margin: 8rem 0 9rem;
          }

          .detail {
            font-weight: 400;
            font-size: 18rem;
            color: #333333;
            line-height: 30rem;
            margin-top: 20rem;
            font-family: PingFangSC-Regular;
          }
        }
      }
    }
  }

  .pagination {
    margin: -50rem 0 67rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &>div {
      width: 24rem;
      height: 24rem;
      line-height: 24rem;
      border-radius: 2rem;
      font-weight: 400;
      font-size: 14rem;
      color: #999999;
      margin: 0 5rem;
      text-align: center;
      cursor: pointer;
    }

    &>div.active {
      background: #F7F7F7;
      color: #414141;
    }

    .prev {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
    }

    .next {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
  }
}
</style>